module.exports = __webpack_public_path__ + "img/previous-contest-bg@tl.8b42561.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/previous-contest-bg@tl.svg
// module id = SQhA
// module chunks = 1